import { IInvoice } from '../types/invoice';

export const groupInvoiceTotal = (data: IInvoice[]) => {
    let groupData: any = {};
    let total9 = 0;
    let total10 = 0;
    data.forEach((it) => {

        total9 += it.invoiceTotal ? parseFloat(it.invoiceTotal) : 0;
        total10 += it.actualTotal ? parseFloat(it.actualTotal) : 0;
    });

    groupData = {
        id: ``,
        totalRow: true,
        createdAt: '',
        invoiceTotal: total9,
        'occasion.orderEntity.caseNumber': '',
        'provider.id': '',
        'student.id': '',
        'vendor.id': '',
        'district.id': '',
        'occasion.serviceType.id': '',
        periodStart: '',
        'occasion.caseType': '',
        'occasion.orderType': '',
        payment: [],
        isReadyToSent: '',
        statusDocusign: '',
        status: '',
        updatedAt: '',
        note: '',
        actualTotal: total10,
        paymentInvoices: [],
    };

    return groupData;
};
